module.exports = __webpack_public_path__ + "assets/537005c2fa0a1ac6bf3791a3f60e2b68.mp4";